module.exports = __webpack_public_path__ + "img/.xlsx.682a5c3e.png";